import React, { FC, useContext } from 'react';
import MigrateStaffAccountContext, {
    EMigrateStaffAccountUiState,
    MigrateStaffAccountProvider,
} from '../../contexts/MigrateStaffAccountContext';
import { ERoutes } from '../../util/constants';
import { Switch, Route, Redirect } from 'react-router-dom';
import PageLayout from '../../layout/PageLayout/PageLayout';
import MigrateStaffAccountForm from '../../components/MigrateStaffAccountForm/MigrateStaffAccountForm';
import MigrateStaffAccountPassword from '../../components/MigrateStaffAccountPassword/MigrateStaffAccountPassword';
import MigrateStaffAccountVerify from '../../components/MigrateStaffAccountVerify/MigrateStaffAccountVerify';
import MigrateStaffAccountSuccess from '../../components/MigrateStaffAccountSuccess/MigrateStaffAccountSuccess';
import CardLoader from '../../components/Loader/Loader';

const MigrateStaffAccountRouter: FC = () => {
    return (
        <Switch>
            <Route exact path={ERoutes.staffMigrateAccount}>
                <PageLayout showHeader={false}>
                    <MigrateStaffAccountForm />
                </PageLayout>
            </Route>
            <Route exact path={ERoutes.staffMigrateAccountPassword}>
                <PageLayout showHeader={false}>
                    <MigrateStaffAccountPassword />
                </PageLayout>
            </Route>
            <Route exact path={ERoutes.staffMigrateAccountVerify}>
                <PageLayout>
                    <MigrateStaffAccountVerify />
                </PageLayout>
            </Route>
            <Route exact path={ERoutes.staffMigrateAccountSuccess}>
                <PageLayout>
                    <MigrateStaffAccountSuccess />
                </PageLayout>
            </Route>
        </Switch>
    );
};

const MigrateStaffAccountUi: FC = () => {
    const { migrateStaffAccountUiState, redirectUrl } = useContext(MigrateStaffAccountContext);
    switch (migrateStaffAccountUiState) {
        case EMigrateStaffAccountUiState.default:
        case EMigrateStaffAccountUiState.ready:
        case EMigrateStaffAccountUiState.loading:
        case EMigrateStaffAccountUiState.softError:
            return <MigrateStaffAccountRouter />;
        case EMigrateStaffAccountUiState.userExists:
            return (
                <>
                    <Redirect to={ERoutes.staffMigrateAccount} />
                    <MigrateStaffAccountRouter />
                </>
            );
        case EMigrateStaffAccountUiState.verificationRequired:
            return (
                <>
                    <Redirect to={ERoutes.staffMigrateAccountVerify} />
                    <MigrateStaffAccountRouter />
                </>
            );
        case EMigrateStaffAccountUiState.verified:
            return (
                <>
                    <Redirect to={ERoutes.staffMigrateAccountSuccess} />
                    <MigrateStaffAccountRouter />
                </>
            );
        case EMigrateStaffAccountUiState.login:
            return (
                <>
                    <PageLayout>
                        <CardLoader />
                    </PageLayout>
                    {window.location.assign(redirectUrl)}
                </>
            );
        case EMigrateStaffAccountUiState.fatalError:
            return <Redirect to={ERoutes.error} />;
        default:
            console.error('Migrate staff account ui state set incorrectly');
            return <Redirect to={ERoutes.error} />;
    }
};

const MigrateStaffAccountScreen: FC = () => {
    return (
        <MigrateStaffAccountProvider>
            <MigrateStaffAccountUi />
        </MigrateStaffAccountProvider>
    );
};

export default MigrateStaffAccountScreen;
